import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import {
  Lock,
  Mail,
  Eye,
  EyeOff,
  CheckCircle,
  AlertCircle,
} from "lucide-react";
import logo from "../../assets/think_cloudly_logo_transparent.png";

const LoginForm = () => {
  const [step, setStep] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);

  const { requestOTPLogin, verifyOTP } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    if (step === "login") {
      const result = await requestOTPLogin(email, password);
      setMessage(result.message);
      setMessageType(result.success ? "success" : "error");
      setLoading(false);
      if (result.success) {
        setStep("otp");
      }
    } else if (step === "otp") {
      const result = await verifyOTP(email, otp);
      setMessage(result.message);
      setMessageType(result.success ? "success" : "error");
      setLoading(false);
      if (result.success) {
        setEmail("");
        setPassword("");
        setOtp("");
      }
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <img
              src={logo}
              alt="Think Cloudly Logo"
              className="w-18 h-18 object-contain"
              draggable={false}
            />
          </div>
          {/* <h2 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h2>
          <p className="text-gray-600">Sign in to your trainer account</p> */}
        </div>

        {message && (
          <div
            className={`mb-6 p-4 rounded-lg flex items-center ${
              messageType === "success"
                ? "bg-green-50 text-green-800 border border-green-200"
                : "bg-red-50 text-red-800 border border-red-200"
            }`}
          >
            {messageType === "success" ? (
              <CheckCircle className="w-5 h-5 mr-3 flex-shrink-0" />
            ) : (
              <AlertCircle className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {step === "login" ? (
            <>
              <div>
                <label>Email Address</label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-12 pr-4 py-3 w-full rounded-lg border"
                    placeholder="trainer@example.com"
                    required
                  />
                </div>
              </div>

              <div>
                <label>Password</label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 -translate-y-1/2" />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-12 pr-12 py-3 w-full rounded-lg border"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2"
                  >
                    {showPassword ? <EyeOff /> : <Eye />}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div>
              <label>Enter OTP</label>
              <div className="relative">
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="pl-4 pr-4 py-3 w-full rounded-lg border"
                  placeholder="Enter the 6-digit OTP"
                  required
                />
              </div>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-[#FC7A69] hover:bg-[#e45c53] text-white rounded-lg font-semibold transition"
          >
            {loading
              ? "Processing..."
              : step === "login"
              ? "Send OTP"
              : "Verify OTP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
